import { Grid } from '@consta/uikit/Grid'
import { Text } from '@consta/uikit/Text'
import cn from 'classnames'
import type { FC } from 'react'

import { items } from './items'
import css from './NewImportFromLocalFilesSelector.css'
import { NewImportGridItem } from './NewImportGridItem'
import type { NewImportFromLocalFilesSelectorProps as Props } from './types'

const breakpoints = { 1200: { cols: 3 }, 820: { cols: 2 } }

export const NewImportFromLocalFilesSelector: FC<Props> = ({ getLinkOnImport, onSelect }) => {
  return (
    <div className={css.container}>
      <Text size="m" view="secondary" weight="regular" className={css.title}>
        Загрузка файлов с компьютера
      </Text>
      <Grid cols={1} gap="m" breakpoints={breakpoints}>
        {items.map(({ icon: Icon, title, description, mode, disabled = true }) => {
          const gridClass = cn(css.card, {
            [css.disabledCard]: disabled,
            [css.selectedCard]: !disabled,
          })
          const link = getLinkOnImport(mode)
          const onSelectAction = link ? undefined : onSelect
          return (
            <NewImportGridItem
              key={title}
              title={title}
              gridClass={gridClass}
              disabled={disabled}
              Icon={Icon}
              description={description}
              mode={mode}
              link={link}
              onSelect={onSelectAction}
            />
          )
        })}
      </Grid>
    </div>
  )
}
